import _ from 'lodash';

import { convertTimestringsToDateObjects } from 'common/utils';

/**
 * Determines whether the outlier modal should be shown based on chart type and context.
 */
export const shouldShowOutlierModal = ({
  type,
  showOverlay,
  title,
  displayOutliers
}) => {
  const isSpectrumChart = (type === 'spectrum' || type === 'demod_spectrum') || title === 'spectrum';
  const isTrendChart = type === 'trend' || title === 'trend';
  const isWaveformChart = type === 'waveform' || title === 'waveform';

  if (isSpectrumChart && showOverlay) {
    return false;
  }

  if (isWaveformChart && showOverlay) {
    return false;
  }

  if (isTrendChart && (showOverlay || displayOutliers === false)) {
    return false;
  }

  return true;
};

export const buildSelectionState = (selection, {
  xTitle,
  xUnit,
  xIsDate,
  yTitle,
  yUnit
}) => ({
  ...selection,
  xTitle: `${xTitle}`,
  xUnit: `${xUnit}`,
  isDate: xIsDate,
  yTitle: `${yTitle}`,
  yUnit: `${yUnit}`
});

export const getRulDatapoints = (data, rulFdp, rulStartTime) => {
  let rulFdpDatapoint = {};
  let rulStartTimeDatapoint = {};

  if (rulFdp) {
    const rulFdpObject = convertTimestringsToDateObjects([rulFdp])[0];
    rulFdpDatapoint = data.find(d => d.x.toString() === rulFdpObject.toString()) || {};
  }
  if (rulStartTime) {
    const rulStartTimeObject = convertTimestringsToDateObjects([rulStartTime])[0];
    rulStartTimeDatapoint = data.find(d => d.x.toString() === rulStartTimeObject.toString()) || {};
  }

  return { rulFdpDatapoint, rulStartTimeDatapoint };
};

export const getInitialSelectionPoint = (data, oldSelectedIdx) => {
  if (oldSelectedIdx !== undefined) {
    return data[oldSelectedIdx];
  }
  return data[data.length - 1];
};

export const getSelectionAtBrushEnd = (data, brushSelection, axisProps) => {
  if (!data.length) {
    return null;
  }

  const basePoint = data[data.length - 1];
  const selection = brushSelection && brushSelection.length
    ? { ...basePoint, x: brushSelection[1] }
    : basePoint;

  return buildSelectionState(selection, axisProps);
};

export const findSelectionIndex = (data, selectionX) => data.findIndex(d => _.isEqual(d.x, selectionX));

export const getNextPointsOnClick = (currentPoints, selection) => {
  if (currentPoints === undefined || currentPoints.length === 0) {
    return [_.cloneDeep(selection)];
  }
  if (currentPoints.length === 1) {
    return [...currentPoints, _.cloneDeep(selection)];
  }
  if (currentPoints.length === 2) {
    return [];
  }
  return currentPoints;
};
